import http from '@core/fetch'

export default {
  overview: body =>
    http('/p/wedding/index.php/admin/APIMerchantDataStatistics/storeOverview', {
      body
    }),

  trend: body =>
    http(
      '/p/wedding/index.php/admin/APIMerchantDataStatistics/storeDirection',
      { body }
    ),

  source: body =>
    http('/p/wedding/index.php/admin/APIMerchantDataStatistics/storeSource', {
      body
    })
}
